import { NgModule } from '@angular/core';
import { MyShopDataAccessModule } from '@my-shop/data-access';
import { MyShopFeatureModule } from '@my-shop/feature';

@NgModule({
  imports: [MyShopDataAccessModule, MyShopFeatureModule],
})
export class SdvorMyShopShellModule {}
